import React from "react";
import { Box, Grid, Skeleton, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const LearningPaths = ({ competencePahts }) => {
  return (
    <>
      <Typography
        component="h4"
        variant="h7"
        sx={{
          textAlign: "center",
          lineHeight: "40px",
          color: 'primary.main',
        }}
      >
        Odblokowane ścieżki nauczania:
      </Typography>
      <Grid container spacing={4}>
        {competencePahts.length > 0 ? (
          competencePahts.map((learningPath) => (
            <Grid
              key={learningPath.id}
              item
              xs={12}
              md={4}
              lg={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                opacity: learningPath.isUnlocked ? 1 : 0.4,
              }}
            >
              <Tooltip
                disableHoverListener={learningPath.isUnlocked}
                title="Odznaka jeszcze nie odblokowana, ale możesz wejść i zobaczyć jakie kwalifikacje są wymagane do jej odblokowania"
              >
                <Box
                  component={Link}
                  to={`/sciezki/${learningPath.id}`}
                  sx={{
                    textDecoration: "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 250,
                  }}
                >
                  <Typography
                    component="h3"
                    variant="h6"
                    align="center"
                    color="text.primary"
                    sx={{
                      height: 54,
                      lineHeight: "30px",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {learningPath.attributes.name}
                  </Typography>

                  <Box
                    sx={{
                      height: 150,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={learningPath.attributes.image.data?.attributes.url}
                      alt=""
                      sx={{
                        maxHeight: 144,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </Tooltip>
            </Grid>
          ))
        ) : (
          <Grid container spacing={4} sx={{ mb: 3, px: 6, pt: 5 }}>
            {[0, 0, 0, 0, 0, 0].map((el, i) => (
              <Grid
                item
                key={i}
                xs={12}
                md={4}
                lg={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: 250,
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width="80%"
                    height={48}
                    sx={{ mb: 2 }}
                  />
                  <Skeleton
                    variant="circular"
                    width={144}
                    height={144}
                  />
                </Box>
              </Grid>

            ))}
          </Grid>
        )}
      </Grid>

    </>
  );
};

export default LearningPaths;
